var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "add-label-dialog",
      attrs: {
        title: _vm.row.groupChatName,
        visible: _vm.dialogVisibleM,
        "modal-append-to-body": true,
        width: "50%",
        "close-on-click-modal": false,
        center: true,
        "close-on-press-escape": true
      },
      on: {
        close: _vm.closeDialog,
        "update:visible": function($event) {
          _vm.dialogVisibleM = $event
        }
      }
    },
    [
      _vm.newEditionDialogVisible
        ? _c("GroupChatDia", { attrs: { idData: _vm.groupChatId } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }